import styled, { css } from 'styled-components';

export const Checkbox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  width: 14px;
  height: 14px;
  border: 2px solid;
  cursor: pointer;
`;

export const Check = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
`;

export const HiddenCheckbox = styled.input`
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;

  &:focus-visible + ${Checkbox} {
    outline: 3px solid black;
    outline-offset: 1px;
  }

  &:not(:checked) + ${Checkbox} {
    ${Check} {
      display: none;
    }
  }

  &:disabled + ${Checkbox} {
    border-color: ${({ theme }) => theme.neutral_300};
    background-color: ${({ theme }) => theme.neutral_300};
    cursor: not-allowed;

    ${Check} {
      color: ${({ theme }) => theme.neutral_300};
    }
  }
`;

const Checkbox_neutral = css`
  ${Checkbox} {
    border-color: ${({ theme }) => theme.neutral_500};

    ${Check} {
      color: ${({ theme }) => theme.neutral_500};
    }
  }
`;

const Checkbox_primary = css`
  ${Checkbox} {
    border-color: ${({ theme }) => theme.primary_300};

    ${Check} {
      color: ${({ theme }) => theme.primary_300};
    }
  }
`;

const Checkbox_danger = css`
  ${Checkbox} {
    border-color: ${({ theme }) => theme.danger_300};

    ${Check} {
      background-color: ${({ theme }) => theme.neutral_100};
      color: ${({ theme }) => theme.danger_300};
    }
  }
`;

const variants = {
  neutral: Checkbox_neutral,
  primary: Checkbox_primary,
  danger: Checkbox_danger,
};

export const CheckboxWrapper = styled.label<{
  $avoidClick?: boolean;
  $variant: 'primary' | 'neutral' | 'danger';
}>`
  ${({ $avoidClick }) => $avoidClick && 'pointer-events: none;'}
  ${({ $variant }) => variants[$variant]};
`;
